export default __webpack_public_path__ + "static/media/login-logo.70d798bc.png";